import { loadPlatformConfig } from './config/loadPlatformConfig';
import { ServiceRegistry } from './ServiceRegistry';
import backendModule from '@platform/backend';

/**
 * Initialize the platform with environment-based configuration
 * This should be called once at application startup before creating stores
 */
export async function initializePlatform(): Promise<ServiceRegistry> {
  // Load configuration from environment
  const config = loadPlatformConfig();
  
  if (backendModule.type !== config.type) {
    throw new Error(`Backend module mismatch. Expected ${backendModule.type}, got ${config.type}`);
  }
  
  // Allow backend to perform any bootstrap logic (e.g., configuring SDKs)
  if (backendModule.bootstrap) {
    await backendModule.bootstrap(config);
  }
  
  // Initialize service registry
  const registry = ServiceRegistry.initialize(config, backendModule);
  
  return registry;
}
